// development in progress do not use

export default class YouTubeVideoPlayer {
    constructor(el, youtubeVideoId, autoplay = false, muted = true) {
        this.el = el;
        this.youtubeVideoId = youtubeVideoId;
        this.autoplay = autoplay ? 1 : 0;
        this.muted = muted;
        this.player = null;
    }

    async init() {
        await this.loadYouTubeAPI();
        this.createPlayer();
    }

    loadYouTubeAPI() {
        return new Promise((resolve) => {
            if (window.YT && YT.Player) {
                resolve();
            } else {
                const checkInterval = setInterval(() => {
                    if (window.YT && YT.Player) {
                        clearInterval(checkInterval);
                        resolve();
                    }
                }, 100);
            }
        });
    }

    createPlayer() {
        this.player = new YT.Player('player', {
            height: '100%',
            width: '100%',
            videoId: this.youtubeVideoId,
            playerVars: {
                'autoplay': this.autoplay,
                'controls': 0,
                'modestbranding': 1,
                'rel': 0,
                'showinfo': 0,
            },

            events: {
                'onReady': this.onPlayerReady.bind(this)
            }
        });
    }

    onPlayerReady(event) {
        const playButton = this.el.querySelector(".play-pause-btn");
        const audioControl = this.el.querySelector(".audio-control");

        // Функция для определения состояния воспроизведения видео
        const isVideoPlaying = () => {
            const playerState = this.player.getPlayerState();
            return playerState === YT.PlayerState.PLAYING;
        };

        const isMuted = () => {
            return this.player.isMuted();
        };

        if (isVideoPlaying()) {
            playButton.setAttribute("data-click", 1);
            playButton.innerHTML = "Pause";
        } else {
            playButton.setAttribute("data-click", 2);
            playButton.innerHTML = "Play";
        }

        if (isMuted()) {
            audioControl.classList.add("unmute");
        } else {
            audioControl.classList.remove("unmute");
        }

        playButton.addEventListener("click", () => {
            if (!isVideoPlaying()) {
                this.player.playVideo();
                playButton.setAttribute("data-click", 1);
                playButton.innerHTML = "Pause";
            } else {
                this.player.pauseVideo();
                playButton.setAttribute("data-click", 2);
                playButton.innerHTML = "Play";
            }
        });

        audioControl.addEventListener("click", () => {
            if (isMuted()) {
                this.player.unMute();
                audioControl.classList.remove("unmute");
            } else {
                this.player.mute();
                audioControl.classList.add("unmute");
            }
        });

        // Устанавливаем начальное состояние мута согласно заданным параметрам
        if (this.muted) {
            this.player.mute();
        } else {
            this.player.unMute();
        }
    }
}
